import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgInfoOutline = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M1.548 8a6.452 6.452 0 1 1 12.904 0A6.452 6.452 0 0 1 1.548 8M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 12c.551 0 1-.449 1-1V7.878c0-.551-.449-1-1-1s-1 .449-1 1V11c0 .551.449 1 1 1M7 5c0 .551.449 1 1 1s1-.449 1-1-.449-1-1-1-1 .449-1 1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgInfoOutline);
export default ForwardRef;
